/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { IRewardsAndOffers } from '../models/b2b';
import { determineMembershipLevel, MembershipLevel } from '../components/Utils';

interface IProviderProps {
  children: React.ReactNode;
  rewardsAndOffers: IRewardsAndOffers | null;
}

const LegacyTiersContext = React.createContext<any>(null);

const LegacyTiersProvider = ({
  children,
  rewardsAndOffers,
}: IProviderProps) => {
  const membershipLevel: MembershipLevel =
    determineMembershipLevel(rewardsAndOffers);

  return (
    <LegacyTiersContext.Provider
      value={{
        membershipLevel,
      }}
    >
      {children}
    </LegacyTiersContext.Provider>
  );
};

export { LegacyTiersProvider, LegacyTiersContext };
